import { Post } from '@wellesley/openapi'

const getLevel = (p: Post) => p.path.length

const sortByPinnedParam = (a: Post, b: Post) => {
  if (a.pinned && !b.pinned) return -1
  if (!a.pinned && b.pinned) return 1

  if (a.pinned && b.pinned) {
    return getLevel(a) - getLevel(b)
  }

  return 0
}

export default sortByPinnedParam
